import { Tables } from "@/lib/supabase/supabase_types_override";
import { isEqual } from "lodash";
import { createQuestionIdMapping } from "./createQuestionIdMapping";
import { transformConditionals } from "./transformConditionals";
import { QuestionConditionalLogicChangedChange } from "@/features/survey_sync/types/syncCheckResult";

export const checkIfConditionalsChanged = (
  question: Tables<"question">,
  templateQuestion: Tables<"survey_bank_question_bank">,
  surveyQuestions: Tables<"question">[]
): QuestionConditionalLogicChangedChange | false => {
  const questionConditionals = question.selected_configuration?.conditionals;
  const templateConditionals = templateQuestion.selected_configuration?.conditionals;

  // If both don't have conditionals, no change
  if (!questionConditionals && !templateConditionals) return false;

  // If one has conditionals and the other doesn't, it's a change
  if (!questionConditionals || !templateConditionals) {
    return {
      type: "QUESTION_CONDITIONAL_LOGIC_CHANGED",
      context: {
        instanceConditionals: questionConditionals || {},
        templateConditionals: templateConditionals || {},
        changedFields: ["conditionals"],
      },
    };
  }

  // Create ID mappings to normalize the conditionals for comparison
  const { templateToSurvey } = createQuestionIdMapping(surveyQuestions);

  // Transform template conditionals to use survey question IDs
  const normalizedTemplateConditionals = transformConditionals(
    templateConditionals,
    templateToSurvey
  );

  // Compare the conditionals
  const hasChanged = !isEqual(questionConditionals, normalizedTemplateConditionals);

  if (hasChanged) {
    // Find which fields changed
    const changedFields: string[] = [];

    // Compare where conditions
    if (!isEqual(questionConditionals.where, normalizedTemplateConditionals?.where)) {
      changedFields.push("where");
    }

    // Compare enabled flag
    if (!isEqual(questionConditionals.enabled, normalizedTemplateConditionals?.enabled)) {
      changedFields.push("enabled");
    }

    return {
      type: "QUESTION_CONDITIONAL_LOGIC_CHANGED",
      context: {
        instanceConditionals: questionConditionals,
        templateConditionals: normalizedTemplateConditionals || {},
        changedFields,
      },
    };
  }

  return false;
};